import React from 'react'

export function DividerEllipseBottom() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1440" height="44" fill="none" viewBox="0 0 1440 44">
      <path fill="#F7F7F7" d="M711.265 44C433.499 44 0 13.2 0 13.2V0h1440v13.2S995.854 44 711.265 44z"></path>
    </svg>
  )
}
